import React, { FunctionComponent } from 'react'
import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  ToastNotifications,
} from '@lightspeed/design-system-react'
import { T, useT } from '@transifex/react'
import { useSaleSyncManager } from '../../../ng-compat/hooks'

interface ActionOfflineSalesProps {
  close: (salesSynced?: boolean) => void
}

export const ActionOfflineSales: FunctionComponent<ActionOfflineSalesProps> = ({
  close,
}) => {
  const t = useT()
  const saleSyncManager = useSaleSyncManager()
  const uploadSalesCount = saleSyncManager.uploadSalesCount
  const [syncing, setSyncing] = React.useState(false)

  const failureToast = () => {
    ToastNotifications.negative(
      t('There was a problem syncing your offline sales. Please try again.')
    )
  }

  const sync = async () => {
    setSyncing(true)
    try {
      await saleSyncManager.retryUnsyncedSales()
      if (saleSyncManager.unsyncedSalesCount) {
        failureToast()
        close()
      } else {
        close(true)
      }
    } catch (error) {
      setSyncing(false)
      failureToast()
    }
  }

  return (
    <Modal onClose={() => close()}>
      <ModalHeader>
        <T
          _str="{uploadSalesCount, plural, one {You have {uploadSalesCount} offline sale} other {You have {uploadSalesCount} offline sales}}"
          uploadSalesCount={uploadSalesCount}
        />
      </ModalHeader>
      <ModalContent>
        <T _str="Before you can switch registers, it’s important to have all your sales synced to our servers, otherwise your sales will be deleted and cannot be recovered." />
      </ModalContent>
      <ModalActions>
        <div className="vd-gtn-group">
          <Button disabled={syncing} onClick={sync}>
            <T
              _str="{uploadSalesCount, plural, one{Sync offline sale} other{Sync offline sales}}"
              uploadSalesCount={uploadSalesCount}
            />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
